module.exports = __webpack_public_path__ + "01_long_gray.9a8b06a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/01_long_gray.png
// module id = Wpuh
// module chunks = 0